<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <!-- 通知に数字を入れたもの -->
        <div class="c-result-font-roboto--500 custom-news">
          <span v-if="unreadNum > 0" class="custom--v-badge">{{ unreadNum }}</span>
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon color="black">mdi-bell-outline</v-icon>
          </v-btn>
        </div>
      </template>
      <v-card style="width:400px">
        <v-list>
          <v-list-item>
            <v-list-item-title>お知らせ</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-container
          id="scroll-target"
          style="max-height: 70vh; padding: 0px;"
          class="overflow-y-auto"
          v-if="newsList.length"
        >
          <v-list>
            <v-list-item v-for="news in newsList" :key="news.content">
              <v-list-item-content>
                <v-list-item-subtitle>{{news.start}}</v-list-item-subtitle>
                <span style="font-size: 90%" v-html="news.content"></span>
              </v-list-item-content>
              <v-list-item-action v-if="news.is_read">
                <v-icon small color="info">mdi-check</v-icon>
              </v-list-item-action>
              <v-list-item-action v-if="!news.is_read">
                <v-chip class="white--text" color="pink" @click="read(news.id)">
                  未読
                </v-chip>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-container>
        <v-list v-else>
          <v-list-item>
            <v-list-item-subtitle>現在、お知らせはありません。</v-list-item-subtitle>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <v-dialog
      v-if="newsList.length"
      v-model="dialog"
      persistent
      :max-width="400"
    >
      <v-card dense flat>
        <v-card-title class="headline">
          お知らせ
        </v-card-title>
        <v-card-text>
          新しいお知らせがあります。<br>
          画面右上のベルアイコン<v-icon>mdi-bell</v-icon>から、お知らせを確認してください。
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="dialog = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'

const listNewsQuery = (campaignId) => `
  query listNews {
    listNews(campaign_id: "${campaignId}") {
      news {
        id
        start
        content
        read_info {
          id
        }
      }
    }
  }
`
const listNews = async (campaignId) => {
  const { data: { listNews: data } } = await GraphqlAPI(listNewsQuery(campaignId))
  return data
}

const createReadMutation = (newsId) => `
  mutation createRead {
    createRead (news_id: "${newsId}") {
      id
      meta
    }
  }
`
const createRead = async (newsId) => {
  const { data: { createRead: data } } = await GraphqlAPI(createReadMutation(newsId))
  return {
    news_id: data.meta
  }
}

export default {
  name: 'news',
  data () {
    return {
      unreadNum: 0,
      dialog: false,
      newsList: {},
      menu: false
    }
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    }
  },
  async mounted () {
    if (!this.campaign.id) {
      await this.$store.dispatch('initCampaign')
    }
    await this.fetchListNews()
    if (this.unreadNum > 0 && this.$route.params.referer && this.$route.params.referer === 'login') {
      this.dialog = true
      this.$route.params.referer = ''
    }
  },
  methods: {
    async fetchListNews () {
      try {
        const listNewsResult = await listNews(this.campaign.id)
        const tempNewsList = []
        for (const i in listNewsResult.news) {
          const tempNews = {}
          const start = new Date(listNewsResult.news[i].start * 1000)
          tempNews.start = start.toLocaleDateString()
          tempNews.id = listNewsResult.news[i].id
          tempNews.content = listNewsResult.news[i].content
          tempNews.is_read = !(listNewsResult.news[i].read_info == null)
          if (tempNews.is_read === false) {
            this.unreadNum += 1
          }
          tempNewsList.push(tempNews)
        }
        this.newsList = tempNewsList
      } catch (e) {
        this.$emit('errorHandling', 'お知らせの取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    async read (newsId) {
      try {
        const ress = await createRead(newsId)
        for (const i in this.newsList) {
          if (this.newsList[i].id === ress.news_id) {
            const tempNews = this.newsList[i]
            tempNews.is_read = true
            this.unreadNum -= 1
          }
        }
      } catch (e) {
        this.$emit('errorHandling', '既読更新に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.custom-news {
  position: relative;
  .custom--v-badge {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 8px;
    right: 4px;
    z-index: 1;
    width: 20px;
    height: 20px;
    color: white;
    font-size: 10px;
    border-radius: 50%;
    background-color: #CC1D1D;;
    pointer-events: none;
  }
}
</style>
